export { default as NSpin, spinProps } from './src/Spin';
